// Cached formatter avoids per-call Intl allocation.
const timeFormatter = new Intl.DateTimeFormat(undefined, { hour: "2-digit", minute: "2-digit" });

export const formatTime = (iso: string, customFormatter?: (iso: string) => string): string => {
  if (typeof customFormatter === "function") return customFormatter(iso);
  return timeFormatter.format(new Date(iso));
};

export const formatDivider = (iso: string): string => {
  const date = new Date(iso);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === today.toDateString()) return "Today";
  if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
  return date.toLocaleDateString();
};
